import React from 'react';
import './Modal.css';

export default function Modal({ isOpen, onClose, title, children, maxWidth, style }) {
  if (!isOpen) return null;

  const cardStyle = {
    ...(maxWidth ? { maxWidth, width: `min(${maxWidth}, calc(100vw - 32px))` } : {}),
    ...style
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <div className="modal-card-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-card-body">{children}</div>
      </div>
    </div>
  );
}
